__turbopack_context__.v({
  "className": "display_91d173f4-module__Y5GJYG__className",
});
